import { render, staticRenderFns } from "./DianJinList.vue?vue&type=template&id=01b5d4a4&scoped=true&"
import script from "./DianJinList.vue?vue&type=script&lang=js&"
export * from "./DianJinList.vue?vue&type=script&lang=js&"
import style0 from "./DianJinList.vue?vue&type=style&index=0&id=01b5d4a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5d4a4",
  null
  
)

export default component.exports